import React from 'react'

import { Button, Subsection } from '@fourthwall/components'
import { routing } from '@utils/routing'

import * as S from './Analytics.styled'

export const Analytics = () => {
  return (
    <Subsection title="Analytics and tracking pixels">
      <S.Description>You can manage your tracking pixels from the Analytics tab.</S.Description>
      <S.ButtonWrapper>
        <Button label="Manage tracking pixels" to={routing.analytics.overview.trackingPixels} />
      </S.ButtonWrapper>
    </Subsection>
  )
}
